import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import PresentationPage from './components/presentationPage/PresentationPage';
import './App.css';
import PreviewPage from "./components/previewPage/PreviewPage";
import LoginPage from './components/auth/LoginPage';
import RegisterPage from './components/auth/RegisterPage';
import ProfilePage from './components/profile/ProfilePage';
import EmailSentPage from './components/auth/EmailSentPage';
import VerifyPage from "./components/auth/VerifyPage";
import LandingPage from './components/landing/LandingPage'; 
import Footer from './components/common/Footer';
import FeedbackModal from './components/profile/FeedbackModal';
import NotFoundPage from "./components/common/NotFoundPage";

function AppWrapper({ onOpenFeedback }) {
    const location = useLocation();
    const isStaticMode = process.env.REACT_APP_STATIC_MODE === 'true';
    const isBroadcast =
        location.pathname.startsWith('/presentation') ||
        location.pathname.startsWith('/preview');

    return (
        <div className="app-shell">
            <div className="app-content">
                <Routes>
                    <Route path="/" element={<LandingPage />} />
                    {!isStaticMode && (
                        <>
                            <Route path="/preview/:id" element={<PreviewPage />} />
                            <Route path="/login" element={<LoginPage />} />
                            <Route path="/register" element={<RegisterPage />} />
                            <Route path="/profile" element={<ProfilePage onOpenFeedback={onOpenFeedback} />} />
                            <Route path="/verify" element={<VerifyPage />} />
                            <Route path="/email-sent" element={<EmailSentPage />} />
                            <Route path="/presentation/:id" element={<PresentationPage />} />
                        </>
                    )}
                    <Route path="*" element={<NotFoundPage />} />

                </Routes>
            </div>

            {!isBroadcast && <Footer onOpenFeedback={onOpenFeedback} />}
        </div>
    );
}

// function App() {
//     const [feedbackOpen, setFeedbackOpen] = useState(false);

//     const openFeedback = () => setFeedbackOpen(true);
//     const closeFeedback = () => setFeedbackOpen(false);

//     return (
//         <Router>
//             <AppWrapper onClick={() => onOpenFeedback(user?.id)} />
//             {feedbackOpen && <FeedbackModal onClose={closeFeedback} />}
//         </Router>
//     );
// }

function App() {
    const [feedbackOpen, setFeedbackOpen] = useState(false);
    const [feedbackUserId, setFeedbackUserId] = useState(null);

    const openFeedback = (uid) => {
        setFeedbackUserId(uid);
        setFeedbackOpen(true);
    };

    const closeFeedback = () => setFeedbackOpen(false);

    return (
        <Router>
            <AppWrapper onOpenFeedback={openFeedback} />
            {feedbackOpen && (
                <FeedbackModal onClose={closeFeedback} userId={feedbackUserId} />
            )}
        </Router>
    );
}


export default App;
